
// STYLES
import { useState } from "react";
import * as Style from "./ToggleArrowsStyle";

// LIBRARIES

// MISC
import { IProps } from "./ToggleArrowsModel";

// ASSETS

// REDUX

// COMPONENTS

const ToggleArrows = (props: IProps) => {

  // PROPS
  const { onUpArrowClick = () => { }, onDownArrowClick = () => { }, type = "" } = props;

  // CONSTANTS USING LIBRARIES

  // CONSTANTS USING HOOKS
  const [activeArrow, setActiveArrow] = useState("");

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleClickArrow = (arrow: string) => {
    if (arrow === "up") {
      if (activeArrow === "up") {
        setActiveArrow(null);
      } else {
        setActiveArrow("up");
      }

    } else {
      if (activeArrow === "down") {
        setActiveArrow(null);
      } else {
        setActiveArrow("down");
      }
    }
  };

  if (type === "date_picker") {
    return (
      <Style.ArrowsContainerDate>
        <Style.ArrowUp active={activeArrow == "up"} onClick={() => onUpArrowClick()} onMouseEnter={() => setActiveArrow("up")} onMouseLeave={() => setActiveArrow(null)} />
        <Style.ArrowDown active={activeArrow === "down"} onClick={() => onDownArrowClick()} onMouseEnter={() => setActiveArrow("down")} onMouseLeave={() => setActiveArrow(null)} />
      </Style.ArrowsContainerDate>
    );
  } else {
    return (
      <Style.ArrowsContainer>
        <Style.ArrowUp active={activeArrow == "up"} onClick={() => handleClickArrow("up")} />
        <Style.ArrowDown active={activeArrow === "down"} onClick={() => handleClickArrow("down")} />
      </Style.ArrowsContainer>
    );
  }

};

export default ToggleArrows;
